import { CrewTypes } from '../../service/constants';

export const MIN_WIDTH_AIRPORT_NAME = 500;

export const getNoDataMessage = (crewType, airportServices) =>
    crewType === CrewTypes.PCT_CABINSTAFF || crewType === CrewTypes.PCT_SALONSTAFF
        ? Object.entries(airportServices).length === 0
            ? 'messages.noAirportOperations'
            : null
        : 'messages.noAvailableInfoForLeg';
